// src/components/reports/ReportTypeSelector.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useReportContext } from '../../contexts/ReportContext';
import { REPORT_TYPES } from '../../services/ReportService';

/**
 * Component for selecting the type of report to generate.
 * Filters available report types based on the active report category.
 */
const ReportTypeSelector = () => {
  const { t } = useTranslation('reports');
  const { reportType, setReportType, reportCategory } = useReportContext();

  const filteredTypes = REPORT_TYPES.filter(
    (type) => type.category === reportCategory
  );

  return (
    <div className="report-type-selector">
      <div className="report-type-selector-title" id="report-type-label">
        {t('reportType')}
      </div>

      <div
        className="report-type-options"
        role="group"
        aria-labelledby="report-type-label"
      >
        {filteredTypes.map((type) => {
          const isActive = reportType === type.id;
          return (
            <button
              key={type.id}
              type="button"
              className={`report-type-option ${isActive ? 'active' : ''}`}
              aria-pressed={isActive}
              onClick={() => setReportType(type.id)}
            >
              {t(type.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReportTypeSelector;